<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button class="btn-info btn-block" @click="toggleSpam()">
            <span v-if="model.status == 'spam'">Desmarcar como spam</span>
            <span v-else>Marcar como spam</span>
          </d-button>
        </d-list-group-item>
      </d-list-group>
    </d-card-body>

    <d-card-footer class="border-top">
      <d-button class="btn-dark btn-block" @click="goBack">Voltar</d-button>
    </d-card-footer>
  </d-card>
</template>

<script>
export default {
  name: 'sidebar-actions',
  props: {
    title: {
      type: String,
      default: 'Ações',
    },
    model: {
      type: Object,
      default: () => null,
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    toggleSpam() {
      this.$emit('toggleSpam', this.model);
    },
  },
};
</script>
